import type { DateRange, UUID } from '@cobliteam/common-types';
import type * as Actions from './actions';
import { ReportsActionTypes as Types } from './reportsActionTypes';

export const downloadIncidentsReportRequest = (period: DateRange): Actions.DownloadIncidentsReportRequest => ({
  type: Types.DOWNLOAD_INCIDENTS_REPORT_REQUEST,
  payload: period,
});

export const downloadIncidentsReportEnd = (): Actions.DownloadIncidentsReportEnd => ({
  type: Types.DOWNLOAD_INCIDENTS_REPORT_END,
});

export const downloadRoutesPointsReportRequest = (period: DateRange, vehicleId: UUID, sampleInMinutes?: string): Actions.DownloadRoutesPointsReportRequest => ({
  type: Types.DOWNLOAD_ROUTES_POINTS_REPORT_REQUEST,
  payload: { period, vehicleId, sampleInMinutes },
});

export const downloadRoutesPointsReportEnd = (): Actions.DownloadRoutesPointsReportEnd => ({
  type: Types.DOWNLOAD_ROUTES_POINTS_REPORT_END,
});
